import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './index'
import { RfqParams } from '../api/generated'
import {
  ConsequeceOfChangeUserChoice,
  ConsequenceOfChangeDialogData,
} from '../types/ConsequenceOfChangeTypes'
import { CocOpenedFromType } from './types'

export interface ModalConsequenceOfChangeProps {
  data: ConsequenceOfChangeDialogData
  handleChoice: (choice: ConsequeceOfChangeUserChoice) => void
  cocOpenedFrom: CocOpenedFromType
}

export interface ModalState {
  modalSendChangesToEysIsOpen: boolean
  modalChangesLostIsOpen: boolean
  modalUploadXmlIsOpen: boolean
  modalUserAccountGdprConsentIsOpen: boolean
  modalRfqSendingState: RfqParams | null
  errorModalState: string | null
  errorIsFatal: boolean
}

const initialState: ModalState = {
  modalSendChangesToEysIsOpen: false,
  modalChangesLostIsOpen: false,
  modalUploadXmlIsOpen: false,
  modalUserAccountGdprConsentIsOpen: false,
  modalRfqSendingState: null,
  errorModalState: null,
  errorIsFatal: false,
}

export const modalSlice = createSlice({
  name: 'modalState',
  initialState,
  reducers: {
    openModalSendChangesToEys: (state) => {
      state.modalSendChangesToEysIsOpen = true
    },
    closeModalSendChangesToEys: (state) => {
      state.modalSendChangesToEysIsOpen = false
    },
    openModalChangesLost: (state) => {
      state.modalChangesLostIsOpen = true
    },
    closeModalChangesLost: (state) => {
      state.modalChangesLostIsOpen = false
    },
    openModalUploadXml: (state) => {
      state.modalUploadXmlIsOpen = true
    },
    closeModalUploadXml: (state) => {
      state.modalUploadXmlIsOpen = false
    },
    openModalUserAccountGdprConsent: (state) => {
      state.modalUserAccountGdprConsentIsOpen = true
    },
    closeModalUserAccountGdprConsent: (state) => {
      state.modalUserAccountGdprConsentIsOpen = false
    },
    setModalRfqSendingState: (
      state,
      action: PayloadAction<RfqParams | null>,
    ) => {
      state.modalRfqSendingState = action.payload
    },
    setErrorModalState: (state, action: PayloadAction<string | null>) => {
      if (state.errorIsFatal && state.errorModalState) {
        // Preserve the first fatal error.
        return
      }
      state.errorModalState = action.payload
    },
    setErrorIsFatal: (state, action: PayloadAction<boolean>) => {
      if (state.errorIsFatal) {
        // Don't allow a non-fatal error to replace a fatal error.
        return
      }
      state.errorIsFatal = action.payload
    },

    closeAllModals: (state) => {
      state.modalSendChangesToEysIsOpen = false
      state.modalChangesLostIsOpen = false
      state.modalUploadXmlIsOpen = false
      state.modalUserAccountGdprConsentIsOpen = false
      state.modalRfqSendingState = null
      state.errorModalState = null
    },
  },
})

export const {
  openModalSendChangesToEys,
  closeModalSendChangesToEys,
  openModalChangesLost,
  closeModalChangesLost,
  openModalUploadXml,
  closeModalUploadXml,
  openModalUserAccountGdprConsent,
  closeModalUserAccountGdprConsent,
  setModalRfqSendingState,
  setErrorModalState,
  setErrorIsFatal,
  closeAllModals,
} = modalSlice.actions

export const getModalState = (state: RootState) => state.modal

export default modalSlice.reducer
